import { RoadmapLayout } from 'apps/main/layouts/roadmap'
import { FrontendRoadmap } from 'apps/main/libs/roadmap/feature-frontend'
import { GetStaticProps } from 'next'
import Axios from 'axios'
import ROADMAP_JSON from 'apps/main/libs/roadmap/feature-frontend/data.json'
import { RoadmapData } from 'apps/main/libs/roadmap/feature-frontend/types'
import CommonHead from 'apps/main/libs/shared/ui-common-head'

export const getStaticProps: GetStaticProps = async () => {
  let roadmapData
  try {
    const response = await Axios.get<RoadmapData>(
      'https://codeit-images.s3.ap-northeast-2.amazonaws.com/roadmaps/data.json',
    )
    roadmapData = response?.data ?? ROADMAP_JSON
  } catch {
    roadmapData = ROADMAP_JSON
  }

  return {
    props: {
      roadmapData,
    },
    revalidate: 60,
  }
}

type PageProps = {
  roadmapData: RoadmapData
}

const Page = ({ roadmapData }: PageProps) => {
  return (
    <>
      <CommonHead
        title="2023 프론트엔드 로드맵 | 코드잇"
        description="프론트엔드 개발자가 되고싶은 분들에게 꼭 필요한 내용만 담은 로드맵입니다."
      />
      <RoadmapLayout roadmap={<FrontendRoadmap roadmapData={roadmapData} />} />
    </>
  )
}

export default Page
